<div class="tw-flex tw-justify-center tw-items-center tw-gap-1 tw-shrink-0 tw-h-6 tw-px-2 tw-bg-transparent tw-border tw-border-solid tw-border-teal-100 tw-rounded-6"
     (click)="openLanguageChangeDrawer()">
  <span class="tw-font-lexend tw-text-100 tw-font-bold tw-text-gray-50">{{appConfig.Shared.LanguagesLong[user?.get('languagePreference')?.toUpperCase()
    || appConfig.Shared.Languages.EN.toUpperCase()]}}</span>
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <mask id="mask0_24481_23258" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="9" height="9">
      <rect x="8.5" y="0.0175781" width="8" height="8" transform="rotate(90 8.5 0.0175781)" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_24481_23258)">
      <path d="M1.16634 2.69274L1.75801 2.10107L4.49967 4.84274L7.24134 2.10107L7.83301 2.69274L4.49967 6.02607L1.16634 2.69274Z" fill="white" />
    </g>
  </svg>
</div>
